import axios from 'axios'

export const api = axios.create({
  // baseURL: 'http://localhost:8080',
  // baseURL: 'https://webauspex-api.app.pb.utfpr.edu.br',
  baseURL: process.env.REACT_APP_API_URL,
})
